module.exports = __webpack_public_path__ + "img/download.6b2cc77a.svg";